import { render, staticRenderFns } from "./publicNumberProduct.vue?vue&type=template&id=bafa689e&scoped=true&"
import script from "./publicNumberProduct.vue?vue&type=script&lang=js&"
export * from "./publicNumberProduct.vue?vue&type=script&lang=js&"
import style0 from "./publicNumberProduct.vue?vue&type=style&index=0&id=bafa689e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.7.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bafa689e",
  null
  
)

export default component.exports